/**
 * The Casbin model every enforcer in this feature is built from.
 *
 * `AuthorizationManagementService.listUsersWithActionOnCamera` answers this
 * matcher in SQL, including Casbin's 10-hop limit on `g` chains, so any change
 * to the matcher must be mirrored in the adapter's
 * `queryUserSubjectsWithActionOnObject`.
 */
export const MODEL = `
[request_definition]
r = sub, dom, obj, act

[policy_definition]
p = sub, dom, obj, act

[role_definition]
g = _, _, _

[policy_effect]
e = some(where (p.eft == allow))

[matchers]
m = ((g(r.sub, p.sub, r.dom) || r.sub == p.sub) && r.dom == p.dom && keyMatch(r.obj, p.obj) && r.act == p.act) || g(r.sub, "tenant_admin", r.dom)`;
